<template>
  <div>
    <van-tabs v-model:active="active">
      <van-tab title="不动产证书">
        <van-cell-group>
          <div v-if="bdcqzsList.length > 0">
            <van-cell v-for="(bdcqzs) in bdcqzsList" :key="bdcqzs.bSM" :title="bdcqzs.bDCQZH">
              <template slot="right-icon" >
                <router-link :to="{path:'/query/bdcqzs',query:{ywh:bdcqzs.iID}}" style="line-height:16px;">
                  <van-button size="mini" type="primary">
                    查看
                  </van-button>
                </router-link>
                <a :href="downloadAtbdcqzsUrl(bdcqzs.iID)" style="line-height:16px;margin-left:5px;">
                  <van-button size="mini" type="warning">
                    下载
                  </van-button>
                </a>
              </template>
            </van-cell>
          </div>
          <div v-else>
            <van-cell title="未查询到相关数据" style="text-align:center;" /></van-cell>
          </div>
        </van-cell-group>
      </van-tab>
      <van-tab title="不动产证明">
         <van-cell-group>
          <div v-if="bdcqzmList.length > 0">
            <van-cell v-for="(bdcqzm) in bdcqzmList" :key="bdcqzm.bSM" :title="bdcqzm.bDCQZMH">
              <template slot="right-icon">
                <router-link :to="{path:'/query/bdcqzm',query:{ywh:bdcqzm.iID}}" style="line-height:16px;">
                  <van-button size="mini" type="primary">
                    查看
                  </van-button>
                </router-link>
                <a :href="downloadAtbdcqzmUrl(bdcqzm.iID)" style="line-height:16px;margin-left:5px;">
                  <van-button size="mini" type="warning">
                    下载
                  </van-button>
                </a>
              </template>
            </van-cell>
          </div>
          <div v-else>
            <van-cell title="未查询到相关数据" style="text-align:center;" /></van-cell>
          </div>
        </van-cell-group>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getAtbdcqzsList } from '@/api/atbdcqzs.js'
import { getAtbdcqzmList } from '@/api/atbdcqzm.js'
import { Toast } from 'vant'
export default {
  filters: {
  },
  data() {
    return {
      active:0,
      bdcqzsList:[{}],
      bdcqzmList:[{}]
    };
  },
  computed: {
  },
  created() {
    // 加载数据
    this.loadData();
  },
  mounted() { },
  methods: { 
    downloadAtbdcqzsUrl(ywh) {
      return process.env.VUE_APP_RECSS_BASE_API + '/ATBDCQZS/GetFile?ywh=' + ywh
    },
    downloadAtbdcqzmUrl(ywh) {
      return process.env.VUE_APP_RECSS_BASE_API + '/ATBDCQZM/GetFile?ywh=' + ywh
    },
     // 加载数据
    async loadData() {
      Toast.loading('正在查询相关信息...')
      // 业务iId
      const iId = this.$route.query.iId || this.$route.params.iId
      Promise.all([getAtbdcqzsList(
        { 
          qlrzjhm: this.$store.getters.webUserInfo.idNumber 
        }), 
        getAtbdcqzmList(
        {
          ywrzjhm: this.$store.getters.webUserInfo.idNumber 
        }
      )])
        .then(([response1, response2]) => {
          this.bdcqzsList = response1.data;
          this.bdcqzmList = response2.data;
        })
        .catch(error => {
          // 设置错误信息
        })
        .finally(() => {
          Toast.clear()
        })
    }
  }
};
</script>
<style scoped lang="scss">
</style>